import type { EndChatSessionBody } from "../types/chat.types";

export async function endChatSessionService(body: EndChatSessionBody) {
  const apiUrl = import.meta.env.VITE_API_URL;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (body.accessToken) {
    headers["Authorization"] = `Bearer ${body.accessToken}`;
  }

  try {
    const fullUrl = `${apiUrl}/logout`;
    const response = await fetch(fullUrl, {
      method: "POST",
      headers,
      credentials: "include",
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        `API error during session end: ${response.status}: ${response.statusText}\n${errorText}`,
      );
    }
  } catch (error) {
    console.error("Failed to call end-session endpoint:", error);
  }
}
